// packages/shared/data/auth/finishLogin.js

import { setGlobalToken } from '@mysimpledb/shared/utils/tokenStore';
import { jwtDecode } from 'jwt-decode';
import { fetchSharedUsers } from '@mysimpledb/shared/data/auth';
import { scheduleSessionExpiryTimer } from '@mysimpledb/shared/utils/sessionExpiry';

export async function finishLogin(
  { token, userId, email, productCode },
  { navigate, setUserId } = {}
) {
  if (!token) {
    throw new Error('Login completed without an authentication token.');
  }

  if (!userId) {
    throw new Error('Login completed without a user ID.');
  }

  setGlobalToken(token);

  try {
    const { exp } = jwtDecode(token) || {};

    localStorage.setItem('token', token);
    localStorage.setItem('userId', String(userId));

    if (productCode) {
      localStorage.setItem('productCode', productCode);
    } else {
      localStorage.removeItem('productCode');
    }

    scheduleSessionExpiryTimer(token);

    if (exp) {
      localStorage.setItem('tokenExpiry', String(exp * 1000));
    } else {
      localStorage.removeItem('tokenExpiry');
    }
  } catch (err) {
    console.error('Unable to initialize authenticated session:', err);

    setGlobalToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpiry');
    localStorage.removeItem('userId');
    localStorage.removeItem('productCode');

    if (setUserId) {
      setUserId(null);
    }

    throw err;
  }

  if (setUserId) {
    setUserId(userId);
  }

  try {
    const sharedUsers = await fetchSharedUsers(email, token);

    localStorage.setItem(
      'usersSharingWithMe',
      JSON.stringify(sharedUsers)
    );
  } catch (err) {
    console.warn(
      'Unable to load users sharing with this account:',
      err
    );

    localStorage.setItem(
      'usersSharingWithMe',
      JSON.stringify([])
    );
  }

  if (typeof navigate === 'function') {
    if (productCode === 'notes') {
      navigate('/mynotes', { replace: true });
      return;
    }

    navigate('/mydata', { replace: true });
  }
}
